export enum Sex {
  Any = 'Any sex',
  Male = 'Male',
  Female = 'Female',
}
